module.exports = __webpack_public_path__ + "static/media/icon_main_img.dc74bde9.dc74bde9.png";